<rt-heading variant="heading">{{ questionTitle() }}</rt-heading>
<span class="description">
  {{ 'app.evaluation_tab.form_details.answers_count' | translate: { count: answersCount() } }}
  @if (commentsCount()) {
    ·
    {{ 'app.evaluation_tab.form_details.comments_count' | translate: { count: commentsCount() } }}
  }
</span>

@if (answersCount() === 0) {
  <rt-empty-state
    icon="thumbs-up-down"
    [title]="'app.evaluation_tab.form_details.no_answers.title' | translate"
    [desc]="'app.evaluation_tab.form_details.no_answers.description' | translate"
    margin-top-small
  />
} @else {
  <div
    #chartContainer
    class="chart-container"
    [style.height.px]="chartHeight()"
    margin-top-small
  ></div>
}
